import { render } from "./UserIndex.vue?vue&type=template&id=876e8d74"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__